<template>
  <div class="steptTwo">
    <!-- 号码、地市、占用费 -->
    <div class="Number_title">
      <span>已选号码：</span>
      <span class="Number_title_con">{{curNumber}}&nbsp;&nbsp;{{curNumbercity}}&nbsp;&nbsp;￥{{(price/100).toFixed(2)}}<span style="text-decoration:line-through;font-size:14px;">￥{{(originalPrice/100).toFixed(2)}}</span></span>
    </div>
    <div class="Number_content">
      <!-- 套餐资费 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">1</span>
          <span class="Number_content_item_title_name">套餐资费</span>
        </div>
        <div class="Number_content_item_con">
          <div class="zifeiItem Number_content_item_con_item" border size="medium" v-for="(item,index) in fareList" :key="index" :class="{ItemAct:index==zifei}"  @click="changeZifeifunc($event,index)" :data-code="index">{{repalceStr(item.fareDescEx)}}</div>
        </div>
		<!-- <div class="tishi">
			温馨提示：<br/>1、新用户入网选择预存100元以上，入网激活成功后，可通过“远微商城”、“远特信时空”公众号领取一次性医用口罩10只。<br/>
			2、本活动所赠送口罩仅用于入网用户本人领取。领取后出现任何转售、倒卖口罩行为所产生后果，由用户本人自行承担。
		</div>	 -->	
      </div>
      <!-- 档位选择 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">2</span>
          <span class="Number_content_item_title_name">档位选择</span>
        </div>
        <div class="Number_content_item_con">
          <div class="dangweiItem Number_content_item_con_item" border size="medium" v-for="(item,index) in dangweiList" :key="index" :class="{ItemAct:item.packageCode==dangwei}"  @click="changeDangweifunc($event,item.packageCode)" :data-code="item.packageCode" :is_quanyi="item.isQuanyi" :month_fee="item.monthFee">{{repalceStr(item.flowDescEx)}}</div>
        </div>
      </div>
      <!-- 资费说明 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">3</span>
          <span class="Number_content_item_title_name">资费说明</span>
          <el-button class="Number_content_item_title_desc" type="text" @click="openZifeidesc">资费详情</el-button>
        </div>
        <div class="zifeishuoming">
          <div>套餐名称：&nbsp;&nbsp;{{zifeistandard.taocanname}}</div>
          <div>套餐月租：&nbsp;&nbsp;{{zifeistandard.taocanyuezu}}</div>
          <div>国内流量：&nbsp;&nbsp;{{zifeistandard.guoneiliuliang}}</div>
          <div>国内语音：&nbsp;&nbsp;{{zifeistandard.guoneiyuyin}}</div>
        </div>
      </div>
      <!-- 权益包 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">4</span>
          <span class="Number_content_item_title_name">权益包
            <span v-if="quanyiDesc==0">(单价15元/个/月)</span>
            <span v-else-if="quanyiDesc==1">(此套餐包含1个权益)</span>
            <span v-else>(此套餐包含2个权益)</span>
          </span>
        </div>
        <div class="Number_content_item_con">
          <div class="quanyiItem Number_content_item_con_item" border size="medium" v-for="(item,index) in quanyiList" :key="index" :data-code="item.code" :is_quanyi="item.isQuanyi" :necessary="item.necessary" :month_fee="item.monthFee" @click="changeQuanyi($event,item.necessary,item.code,index)">{{item.packageName}}</div>
        </div>
      </div>
      <!-- 增值业务 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">5</span>
          <span class="Number_content_item_title_name">增值业务</span>
        </div>
        <div class="Number_content_item_con">
          <div class="zengzhiItem Number_content_item_con_item" border size="medium" v-for="(item,index) in zengzhiList" :key="index" :data-code="item.code" :is_quanyi="item.isQuanyi" :necessary="item.necessary" :month_fee="item.monthFee" @click="changeZengzhi($event,item.necessary,item.code,index)">{{item.packageName}}</div>
        </div>
      </div>
      <!--  预存 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">6</span>
          <span class="Number_content_item_title_name">预存话费</span>
        </div>
        <div class="Number_content_item_con">
          <div class="yucunItem Number_content_item_con_item" border size="medium" v-for="(item,index) in yucunListShow" :key="index" :class="{ItemAct:item.money==yucun}" :data-code="item.ruleCode" :month_fee="item.money" @click="changeYucun($event,item.ruleCode,item.money,index)">{{item.money/100}}元</div>
        </div>
      </div>
      <!--  订单详情 -->
      <div class="Number_content_item">
        <div class="Number_content_item_title">
          <span class="Number_content_item_title_num">7</span>
          <span class="Number_content_item_title_name">订单详情</span>
        </div>
        <div class="orderInfo">
          <div>
            <span class="orderInfo_title">首月服务费：</span>
            <span class="orderInfo_con">￥{{(originalPrice/100).toFixed(2)}}</span>
          </div>
          <div>
            <span class="orderInfo_title">套餐预存费：</span>
            <span class="orderInfo_con">￥{{(yucun/100).toFixed(2)}}</span>
          </div>
          <div>
            <span class="orderInfo_title">首月服务费优惠：</span>
            <span class="orderInfo_con">-￥{{((originalPrice - price)/100).toFixed(2)}}</span>
          </div>
          <div>
            <span class="orderInfo_title">套餐预存费优惠：</span>
            <span class="orderInfo_con">-￥{{yucunSale}}</span>
          </div>
          <!-- <div>
            <span class="orderInfo_title">运费：</span>
            <span class="orderInfo_con">￥{{express}}</span>
          </div> -->
          <div>
            <span class="orderInfo_title">订单总计：</span>
            <span class="orderInfo_con">￥{{(total_money/100).toFixed(2)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="Number_foot">
      <div class="last_step">
        <span class="last_step_btn cursor" @click="gotoStepOne">上一步</span>
      </div>
      <div class="next_step">
        <span class="next_step_agree_btn"><el-checkbox v-model="agreechecked">我已理解并同意</el-checkbox></span>
        <span class="next_step_agree_con cursor" @click="lookAgree">《购卡协议》</span>
        <span class="next_step_agree_con cursor" @click="lookAgree1">《远特通信隐私政策》</span>
        <span class="next_step_btn cursor" @click="gotoStepThree">下一步</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import agree from './agree';
import agree1 from './agree1';
export default {
  name: "stepTwo",
  components: {
    agree,
    agree1
  },
  props: {
    curNumber: String,
    curNumbercity: String,
    curNumberprovincecode : String,
    curNumbercitycode: String,
    pretty: String,
  },
  data(){
    return {
      token : window.localStorage.getItem('token'),
      loading : '',
      originalPrice: '',        //占用费
      fareList: [],             //资费套餐json
      zifei: Number,            //资费code**
      zifeiname : '',           //资费名称
      zifeiDesc : '',           //资费详情

      dangweiList: [],          //档位列表
      dangwei: Number,          //档位code**
      dangweiname : '',         //档位名称
      dangweiIsquanyi : '',     //档位是否为权益套餐
      dangweiIsquanyilen : '',   //权益套餐必选数量
      zifeistandard : Object,   //第三项资费说明
      
      quanyiList : [],          //权益列表
      quanyiListChoose : '',    //权益code列表**
      quanyiDesc : 0,           //权益名称说明
      // quanyiNum : '',           //最多可以选几个权益包：全部/一个/两个
      quanyilayerTitle : '',    //权益说明弹出框名称
      quanyilayerCon : '',      //权益说明弹出框内容

      zengzhiList : [],         //增值列表
      zengzhiListChoose : '',   //增值code列表**
      zengzhiDesc : 0,          //增值名称说明
      zengzhilayerTitle : '',   //增值说明弹出框名称
      zengzhilayerCon : '',     //增值说明弹出框内容

      yucunList: [],            //预存列表
      yucunListShow: [],        //预存显示列表
      yucun: 0,                 //预存钱数**
      yucuncode: '',            //预存code

      balance_threshold : 0,    //卡内最低余额

      taocanMoney : 0,          //当前套餐money
      quanyiMoney : 0,          //当前权益money
      zengzhiMoney : 0,         //当前增值money
      price: '0.00',             //占用费优惠
      yucunSale : '0.00',       //预存优惠
      express : '0.00',         //快递money
      yewu_money : 0,           //业务总计
      total_money : 0,          //总计
      citycode : '',            //城市code
      city : '',                //城市
      // agree : require('./agree.vue'), //协议
      agreechecked: false,
      needImg : 2,
    }
  },
  methods: {
    repalceStr : function(str){
      var a=str.replace("<br/>"," ");
      //console.log(a);
      return a;
    },
    //获取套餐
    getPackege : function(){
      var that = this;
      var params = {
        'token':this.token,
        'phoneNum':this.curNumber
      }
      this.$http.post('/getPacks',params,{emulateJSON: true})
      .then(function(res){ 
        var data = res.data;
        if(data.code == '200'){
          console.log(data)
          that.zifei = 0;
          that.originalPrice = parseFloat(data.data.originalPrice);
          console.log(that.originalPrice)
          that.price = parseFloat(data.data.price);
          that.balance_threshold = data.data.balanceThreshold;
          that.fareList = data.data.fareList;
          that.loading.close();
        }else{
          that.loading.close();
          that.$message({
            message: data.msg,
            type: 'error',
            offset: '300'
          });
        }
      }).catch(function(err){ 
        console.log(err)
        that.alertMsg('套餐查询失败');
      }) 
    },
    Loading : function(text){
      this.loading = Loading.service({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    alertMsg : function(msg){
      this.$message({
        message: msg,
        type: 'error',
        offset: '300'
      });
    },
    //套餐资费切换
    changeZifeifunc : function(e,index){
      var that = this;
      this.zifei = index;
      var curzifei = e.target.getAttribute('data-code');
      var curzifeiname = e.target.innerHTML;
      if( curzifeiname.indexOf('权益') <= '-1' ){ //切换套餐及档位时显示权益包名称描述
        that.quanyiDesc = 0;
        that.dangweiIsquanyilen = '';
      }else{
        that.quanyiDesc = 1;
        that.dangweiIsquanyilen = 1;
      }
    },
    //档位选择切换
    changeDangweifunc : function(e,datacode){
      var that = this;
      this.dangwei = datacode;
      if( datacode == '1353293' ){  //切换套餐及档位时显示权益包名称描述
        that.quanyiDesc = 1;
        that.dangweiIsquanyilen = 1;
      }else if( datacode == '1353294' ){
        that.quanyiDesc = 1;
        that.dangweiIsquanyilen = 1;
      }else if( datacode == '1353295' ){
        that.quanyiDesc = 2;
        that.dangweiIsquanyilen = 2;
      }
    },
    //资费详情显示
    openZifeidesc : function(){
      var that = this;
      this.$alert(that.zifeiDesc, that.repalceStr(that.zifeiname)+" "+that.repalceStr(that.dangweiname), {
        showConfirmButton: false,
        dangerouslyUseHTMLString: true,
        customClass: 'zifeiAlert',
        callback: action => {}
      });
    },
    confirmFunc : function(showConfirmButton,confirmButtonText,cancelButtonText,thenCon,CatchCon,curindex,type){
      //是否显示确定按钮、确定按钮的文本内容、取消按钮的文本内容、1需要加钱2需要减钱、1需要加钱2需要减钱、此个下标、权益或增值
      var that = this;
      this.$confirm(this.quanyilayerCon, this.quanyilayerTitle, {
        showClose: false, //是否显示右上角关闭按钮
        showConfirmButton: showConfirmButton, //是否显示确定按钮
        confirmButtonText: confirmButtonText, //确定按钮的文本内容
        cancelButtonText: cancelButtonText, //取消按钮的文本内容
        dangerouslyUseHTMLString: true, //是否将message属性作为HTML片段处理
        roundButton: true //是否使用圆角按钮
      })
      .then(() => {
        if(thenCon == 0){
        }else if(thenCon == 1){
          if(type == 'quanyi'){
            $('.quanyiItem').eq(curindex).addClass('ItemAct');
            that.quanyiMoney += parseInt($('.quanyiItem').eq(curindex).attr('month_fee'));
            this.getTotalMoney()
          }else if(type == 'zengzhi'){
            $('.zengzhiItem').eq(curindex).addClass('ItemAct');
            that.zengzhiMoney += parseInt($('.zengzhiItem').eq(curindex).attr('month_fee'));
            this.getTotalMoney()
          }
        }else if(thenCon == 2){
          if(type == 'quanyi'){
            $('.quanyiItem').eq(curindex).removeClass('ItemAct');
            that.quanyiMoney -= parseInt($('.quanyiItem').eq(curindex).attr('month_fee'));
            this.getTotalMoney()
          }else if(type == 'zengzhi'){
            $('.zengzhiItem').eq(curindex).removeClass('ItemAct');
            that.zengzhiMoney -= parseInt($('.zengzhiItem').eq(curindex).attr('month_fee'));
            this.getTotalMoney()
          }
        }
      })
      .catch(action => {
        if(CatchCon == 0){
        }else if(CatchCon == 1){
          if(type == 'quanyi'){
            $('.quanyiItem').eq(curindex).removeClass('ItemAct')
            console.log("23224")
            that.quanyiMoney -= parseInt($('.quanyiItem').eq(curindex).attr('month_fee'));
            this.getTotalMoney()
          }else if(type == 'zengzhi'){
            $('.zengzhiItem').eq(curindex).removeClass('ItemAct');
            that.zengzhiMoney -= parseInt($('.zengzhiItem').eq(curindex).attr('month_fee'));
            this.getTotalMoney()
          }
        }
      });
    },
    //选择权益包
    changeQuanyi : function(e,necessary,code,curindex){ 
      var that = this;
      var thisCalssName = e.target.className;
      var thisyesOrNo = true;
      if(thisCalssName.indexOf('ItemAct') <= -1){
        thisyesOrNo = false;
      }else{
        thisyesOrNo = true;
      }
      // console.log(thisyesOrNo)
      this.quanyiList.forEach(function(item,index){
        if(item.code == code){
          that.quanyilayerTitle = item.packageName;
          that.quanyilayerCon = item.feeDescribe;
        }
      })
      if(necessary == '2'){ //如果是必选项
        this.confirmFunc(false,'选择','关闭',0,0,curindex,'quanyi');
      }else{  //如果不是必选项
        console.log(that.dangweiIsquanyilen)
        if(that.dangweiIsquanyilen == ''){   //如果选择的不是权益套餐
          if(thisyesOrNo){
            this.confirmFunc(true,'不选择','关闭',2,0,curindex,'quanyi');
          }else{
            this.confirmFunc(true,'选择','关闭',1,0,curindex,'quanyi');
          }
        }else if(that.dangweiIsquanyilen == 1){
          
          if($('.quanyiItem.ItemAct').length < 1){
            this.confirmFunc(true,'选择','关闭',1,0,curindex,'quanyi');
          }else{
            if(thisyesOrNo){
              this.confirmFunc(true,'不选择','关闭',2,0,curindex,'quanyi');
            }else{
              this.confirmFunc(false,'选择','关闭',1,0,curindex,'quanyi');
            }
          }
        }else if(that.dangweiIsquanyilen == 2){
          if($('.quanyiItem.ItemAct').length < 2){
            this.confirmFunc(true,'选择','关闭',1,0,curindex,'quanyi');
          }else{
            if(thisyesOrNo){
              this.confirmFunc(true,'不选择','关闭',2,0,curindex,'quanyi');
            }else{
              this.confirmFunc(false,'选择','关闭',1,0,curindex,'quanyi');
            }
          }
        }
      }
    },
    //选择增值业务
    changeZengzhi : function(e,necessary,code,curindex){  
      var that = this;
      var thisCalssName = e.target.className;
      var thisyesOrNo = true;
      if(thisCalssName.indexOf('ItemAct') <= -1){
        thisyesOrNo = false;
      }else{
        thisyesOrNo = true;
      }
      this.zengzhiList.forEach(function(item,index){
        if(item.code == code){
          that.quanyilayerTitle = item.packageName;
          that.quanyilayerCon = item.feeDescribe;
        }
      })
      //necessary,
      if(necessary == '2'){ //如果是必选项
        this.confirmFunc(false,'选择','关闭',1,0,curindex,'zengzhi');
      }else{  //如果不是必选项
        if(thisyesOrNo){
          this.confirmFunc(true,'不选择','关闭',2,0,curindex,'zengzhi');
        }else{
          this.confirmFunc(true,'选择','关闭',1,0,curindex,'zengzhi');
        }
      }
    },
    //选择预存
    changeYucun : function($event,ruleCode,money,index){  
      this.yucun = parseInt(money);
      this.yucuncode = ruleCode;
      this.total_money = parseInt(this.price) + parseInt(this.yucun);
      console.log(this.balance_threshold,this.taocanMoney,this.quanyiMoney,this.zengzhiMoney,parseInt(this.balance_threshold)+parseInt(this.taocanMoney)+parseInt(this.quanyiMoney)+parseInt(this.zengzhiMoney),this.yucun,this.price,this.total_money)
    },
    //核算总额
    getTotalMoney : function(){ 
      var that = this;
      this.yewu_money = parseInt(this.balance_threshold)+parseInt(this.taocanMoney)+parseInt(this.quanyiMoney)+parseInt(this.zengzhiMoney);  //总计y####################
      this.yucunListShow = [];  //每次清空预存显示列表################
      this.yucunList.forEach(function(item,index){  //预存显示列表####################
        if( item.money > that.yewu_money ){
          that.yucunListShow.push(item);
          that.yucun = that.yucunListShow[0].money;
          that.yucuncode = that.yucunListShow[0].ruleCode;
        }
      })
      this.total_money = parseInt(this.price) + parseInt(this.yucun);
      console.log(this.balance_threshold,this.taocanMoney,this.quanyiMoney,this.zengzhiMoney,parseInt(this.balance_threshold)+parseInt(this.taocanMoney)+parseInt(this.quanyiMoney)+parseInt(this.zengzhiMoney),this.yucun,this.price,this.total_money)
    },
    //上一步
    gotoStepOne : function(){
      this.$emit('gotoStepOneFunc',0);
    },
    //下一步
    gotoStepThree : function(){
      //判断权益包length
      let quanyilength = $('.quanyiItem.ItemAct').length;
      console.log(quanyilength,this.dangweiIsquanyilen)
      if(!this.dangweiIsquanyilen == ''){
        let quanyimustlength = parseInt(this.dangweiIsquanyilen);
        if(quanyilength != quanyimustlength){
          this.alertMsg('当前套餐必选'+quanyimustlength+'个权益包');
          return;
        }
      }
      //判断是否同意协议
      if(!this.agreechecked){
        this.alertMsg('请阅读并同意购卡协议');
        return;
      }
      this.quanyiListChoose = '';
      if($('.quanyiItem.ItemAct').length > 0){
        for(let i=0;i<$('.quanyiItem.ItemAct').length;i++){
          this.quanyiListChoose += "&"+$('.quanyiItem.ItemAct').eq(i).attr('data-code');
        }
        this.quanyiListChoose = this.quanyiListChoose.substr(1)
      }
      this.zengzhiListChoose = '';
      if($('.zengzhiItem.ItemAct').length > 0){
        for(let i=0;i<$('.zengzhiItem.ItemAct').length;i++){
          this.zengzhiListChoose += "&"+$('.zengzhiItem.ItemAct').eq(i).attr('data-code');
        }
        this.zengzhiListChoose = this.zengzhiListChoose.substr(1)
      }
      var selPackageCode = '';
      if(this.quanyiListChoose != '' && this.zengzhiListChoose != ''){
        selPackageCode = this.quanyiListChoose+"&"+this.zengzhiListChoose;
      }else{
        selPackageCode = this.quanyiListChoose+this.zengzhiListChoose;
      }
      var cityOrProvin = this.curNumbercitycode ? this.curNumbercitycode : this.curNumberprovincecode;
      var params = {
        "token": this.token,
        "phoneNum": this.curNumber,
        "packageCode": this.dangwei,
        "prestoreMoney": this.yucun,
        "ruleCode": this.yucuncode,
        "selPackageCode": selPackageCode,
        "city_code": cityOrProvin,
        "home": this.curNumbercity,
        "pretty": this.pretty
      }
      var that = this;
      this.Loading('订单提交中...');
      this.$http.post('/submitPacks',params,{emulateJSON: true})
      .then(function(res){ 
        that.loading.close();
        var data = res.data;
        if(data.code == '200'){
          console.log(data)
          //that.$emit('needImgFunc','2');
          that.$emit('needImgFunc',data.data.needImg);
          that.$emit('gotoStepThreeFunc',2,data.data.sdk_order_id,that.total_money);
        }else{
          that.alertMsg(data.msg);
        }
      }).catch(function(err){ 
        console.log(err)
        that.alertMsg('订单提交失败');
      }) 
    },
    //购卡协议
    lookAgree : function(){
      var that = this;
      const h = this.$createElement;
      this.$msgbox({
        title: '购卡协议',
        message: h('agree'),
        showClose: false, //是否显示右上角关闭按钮
        showConfirmButton: true, //是否显示确定按钮
        confirmButtonText: '知道啦', //确定按钮的文本内容
        showCancelButton: false, //取消按钮的文本内容
        dangerouslyUseHTMLString: true, //是否将message属性作为HTML片段处理
        roundButton: true, //是否使用圆角按钮
        customClass: 'agree-box', //在这里在这里
      }).then(action => {
      });
    },
    lookAgree1 : function(){
      var that = this;
      const h = this.$createElement;
      this.$msgbox({
        title: '远特通信隐私政策',
        message: h('agree1'),
        showClose: false, //是否显示右上角关闭按钮
        showConfirmButton: true, //是否显示确定按钮
        confirmButtonText: '知道啦', //确定按钮的文本内容
        showCancelButton: false, //取消按钮的文本内容
        dangerouslyUseHTMLString: true, //是否将message属性作为HTML片段处理
        roundButton: true, //是否使用圆角按钮
        customClass: 'agree-box', //在这里在这里
      }).then(action => {
      });
    }
  },
  beforeMount : function(){
    this.Loading('Loading...');
  },
  mounted:function(){
    this.getPackege()
  },
  //当num的值发生变化时，就会调用num的方法，方法里面的形参对应的是num的新值和旧值
  watch:{
    zifei : function(val,oldval){ //套餐code改变时
      var that = this;
      console.log()
      this.fareList.forEach(function(item,index) {
        if(index==that.zifei){  //初次渲染
          that.zifeiname = item.fareDescEx;   //资费名称
          that.dangweiList = item.flowList;  //档位列表
          that.dangweiname = item.flowList[0].flowDescEx;  //档位名称
          that.dangweiIsquanyi = item.flowList[0].isQuanyi;  //档位是否为权益套餐
          item.flowList[0].optionalPackage.forEach(function(item1,index1){  //权益套餐必选个数
            if(item1.isQuanyi == 1){
              that.dangweiIsquanyilen = item1.relevantOptPackage.substr(item1.relevantOptPackage.length-1,1)
            }
          })
          that.taocanMoney = item.flowList[0].monthFee      //当前套餐money####################
          that.zifeistandard = item.flowList[0].standard;
          that.zengzhiList = [];    //每次清空增值列表
          that.quanyiList = [];     //每次清空权益列表
          item.flowList[0].optionalPackage.forEach(function(item,index){  //权益列表和增值列表
            if(item.isQuanyi == 0){
              if(item.code != '000000'){
                if(item.necessary == 1 || item.necessary == 2){
                  that.zengzhiMoney += parseFloat(item.monthFee) //当前增值money####################
                }
                that.zengzhiList.push(item);
              }
            }else if(item.isQuanyi == 1){
              if(item.necessary == 1 || item.necessary == 2){
                that.quanyiMoney += parseFloat(item.monthFee) //当前权益money####################
              }
              that.quanyiList.push(item);
            }
          })
          that.yucunList = item.flowList[0].prestoreMoney; //预存列表
          that.$nextTick(() => {
            for (let i = 0; i < $('.quanyiItem').length; i++) {
              if($('.quanyiItem').eq(i).attr('necessary') == 1 || $('.quanyiItem').eq(i).attr('necessary') == 2){ //权益列表和增值列表显示默认选中
                $('.quanyiItem').eq(i).addClass('ItemAct');
              }
            }
            for (let i = 0; i < $('.zengzhiItem').length; i++) {
              if($('.zengzhiItem').eq(i).attr('necessary') == 1 || $('.zengzhiItem').eq(i).attr('necessary') == 2){ //权益列表和增值列表显示默认选中
                $('.zengzhiItem').eq(i).addClass('ItemAct');
              }
            }
          })
        }
      });
      this.dangwei = this.dangweiList[0].packageCode;  //档位code
      this.zifeiDesc = this.dangweiList[0].feeDescribe;  //资费说明
      this.yucun = this.yucunList[0].money;  //预存钱数
      this.yucuncode = this.yucunList[0].ruleCode;  //预存code
      this.getTotalMoney()
    },
    dangwei : function(val,oldval){ //档位改变时
      var that = this;
      this.zengzhiMoney = 0;  //每次清空增值money################
      this.quanyiMoney = 0;  //每次清空增值money################
      this.dangweiList.forEach(function(item,index) {
        if(item.packageCode==that.dangwei){  
          that.zifeiDesc = item.feeDescribe; //资费详情
          that.zifeistandard = item.standard; //资费说明
          that.dangweiname = item.flowDescEx;  //档位名称
          that.dangweiIsquanyi = item.isQuanyi;  //档位是否为权益套餐
          // that.dangweiIsquanyilen = item.relevantOptPackage; //权益套餐必选个数
          item.optionalPackage.forEach(function(item1,index1){  //权益套餐必选个数
            if(item1.isQuanyi == 1){
              that.dangweiIsquanyilen = item1.relevantOptPackage.substr(item1.relevantOptPackage.length-1,1)
            }
          })
          that.taocanMoney = item.monthFee      //当前套餐money####################
          that.zengzhiList = [];  //每次清空增值列表
          that.quanyiList = [];   //每次清空权益列表
          $('.quanyiItem').removeClass('ItemAct');
          item.optionalPackage.forEach(function(item,index){ //权益列表和增值列表
            if(item.isQuanyi == 0){
              if(item.code != '000000'){
                that.zengzhiList.push(item);
                if(item.necessary == 1 || item.necessary == 2){
                  that.zengzhiMoney += parseFloat(item.monthFee) //当前增值money####################
                  console.log(that.zengzhiMoney)
                }
              }
            }else if(item.isQuanyi == 1){
              if(item.necessary == 1 || item.necessary == 2){
                that.quanyiMoney += parseFloat(item.monthFee) //当前权益money####################
              }
              that.quanyiList.push(item);
            }
          })
          that.yucunList = item.prestoreMoney; //预存列表
          that.$nextTick(() => {
            for (let i = 0; i < $('.quanyiItem').length; i++) {
              if($('.quanyiItem').eq(i).attr('necessary') == 1 || $('.quanyiItem').eq(i).attr('necessary') == 2){ //权益列表和增值列表显示默认选中
                $('.quanyiItem').eq(i).addClass('ItemAct');
              }
            }
            for (let i = 0; i < $('.zengzhiItem').length; i++) {
              if($('.zengzhiItem').eq(i).attr('necessary') == 1 || $('.zengzhiItem').eq(i).attr('necessary') == 2){ //权益列表和增值列表显示默认选中
                $('.zengzhiItem').eq(i).addClass('ItemAct');
              }
            }
          })
        }
      });
      this.getTotalMoney()
    },
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.steptTwo{
  .cursor {
    cursor: pointer;
  }
  .Number_title {
    font-size: 20px;
    line-height: 22px;
    padding: 10px 0 40px;
    border-bottom: 1px solid #E9E9E9;
    .Number_title_con {
      padding-left: 10px;
      color: #1989FA;
      font-size: 22px;
    }
  }
  .Number_content {
    text-align: left;
    .Number_content_item {
      padding-bottom: 30px;
		  .tishi{
			color: red;
			font-size: 14px;
			padding-left: 45px;
			padding-top: 10px;
		  }
      .Number_content_item_title {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        position: relative;
        .Number_content_item_title_num {
          font-size: 46px;
          color: #EEEEEE;
          padding-right: 20px;
        }
        .Number_content_item_title_name {
          font-size: 20px;
          color: #909399;
          span{
            font-size: 16px;
          }
        }
        .Number_content_item_title_desc {
          position: absolute;
          right: 0;
          color: #1989FA;
        }
      }
      .Number_content_item_con {
        display: flex;
        padding-left: 45px;
        flex-wrap: wrap;
        .Number_content_item_con_item{
          color: #606266;
          padding: 7px 10px;
          font-size: 14px;
          border:1px solid #DCDFE6;
          border-radius:4px;
          margin-right: 20px;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .ItemAct {
          color: #1989FA;
          border:1px solid #1989FA;
        }
      }
      .zifeishuoming {
        padding-left: 45px;
      }
    }
    .Number_content_item:nth-last-of-type(1) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding:50px 50px 50px 0;
      border-top: 1px solid #DCDFE6;
      border-bottom: 1px solid #DCDFE6;
      .orderInfo {
        div {
          font-size: 20px;
          color: #909399;
          text-align: right;
          display: flex;
          width: 300px;
          .orderInfo_title {
            flex: 1;
            text-align: right;
          }
          .orderInfo_con {
            width: 45%;
            color: #5CB87A;
          }
        }
      }
    }
  }
  .Number_foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 60px 50px 50px 0;
    .last_step {
      .last_step_btn {
        font-size: 14px;
        padding: 10px 25px;
        border: 1px solid #DCDFE6;
        border-radius:4px;
        color: #606266;
      }
    }
    .next_step{
      .next_step_agree_con {
        color: #1989FA;
        font-size: 20px;
      }
      .next_step_btn {
        background: #1989FA;
        color: #FFFFFF;
        font-size: 22px;
        border-radius:6px;
        padding: 13px 30px;
      }
    }
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style lang="less">
.zifeiAlert {
  width: 600px;
  height: 400px;
  overflow: auto;
}
.agree-box .el-message-box__content {
  height: 400px;
  overflow: auto;
}
</style>
